import React, {Component} from 'react';
import NotFound from '../components/NotFound/NotFound';

export default class NotFoundScreen extends Component {

  render() {
    return(
      <NotFound />
    )
  }
}